import { Box, Pagination } from '@mui/material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { BRAND_LUXE_PRIMARY } from './brandDashboardTokens';

export function BrandCampaignsListPagination({
    page,
    totalPages,
    onChange,
}: {
    page: number;
    totalPages: number;
    onChange: (page: number) => void;
}) {
    if (totalPages <= 1) return null;

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2 }}>
            <Pagination
                count={totalPages}
                page={page}
                onChange={(_, p) => onChange(p)}
                size="medium"
                sx={{
                    '& .MuiPaginationItem-root': { color: '#adaaaa', fontSize: 13 },
                    '& .MuiPaginationItem-root.Mui-selected': {
                        bgcolor: BRAND_LUXE_PRIMARY,
                        color: '#392700',
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                    },
                }}
            />
        </Box>
    );
}
